(function () {
  'use strict';

  var root = document.documentElement;
  var MOBILE = '(max-width: 767px)';
  var observer;

  function init() {
    var bar = document.querySelector('.sticky_add_to_cart');

    if (!bar) {
      root.style.setProperty('--fb-sticky-atc-height', '0px');
      root.removeAttribute('data-fb-sticky-atc');
      return;
    }

    var panel = bar.querySelector('[x-show="openDetailOnMobile"]');
    var mobile = window.matchMedia(MOBILE);

    function update() {
      var height = bar.offsetHeight;

      var expanded = mobile.matches && height > 0 && !!panel && panel.offsetHeight > 0;

      root.style.setProperty('--fb-sticky-atc-height', height + 'px');

      if (expanded) {
        root.setAttribute('data-fb-sticky-atc', 'expanded');
      } else {
        root.removeAttribute('data-fb-sticky-atc');
      }
    }

    update();

    if (window.ResizeObserver) {
      observer = new ResizeObserver(update);
      observer.observe(bar);
    } else {
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('scroll', update, { passive: true });
    }

    if (mobile.addEventListener) {
      mobile.addEventListener('change', update);
    }
  }

  function watchPostscript() {
    var TEASER_MAX_FRACTION = 0.5;
    var widget = null;
    var widgetObserver;

    function evaluate() {
      if (!widget || !widget.isConnected) {
        root.removeAttribute('data-fb-ps-teaser');
        return;
      }

      var rect = widget.getBoundingClientRect();
      var visible = rect.height > 0 && window.getComputedStyle(widget).display !== 'none';
      var isTeaser = visible && rect.height < window.innerHeight * TEASER_MAX_FRACTION;

      if (isTeaser) {
        root.setAttribute('data-fb-ps-teaser', '');
      } else {
        root.removeAttribute('data-fb-ps-teaser');
      }
    }

    function attach(el) {
      if (widget === el) return;
      widget = el;
      if (widgetObserver) widgetObserver.disconnect();
      if (window.ResizeObserver) {
        widgetObserver = new ResizeObserver(evaluate);
        widgetObserver.observe(widget);
      }
      evaluate();
    }

    var existing = document.getElementById('ps__widget');
    if (existing) attach(existing);

    new MutationObserver(function () {
      var el = document.getElementById('ps__widget');
      if (el && el !== widget) {
        attach(el);
      } else if (!el && widget) {
        widget = null;
        root.removeAttribute('data-fb-ps-teaser');
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function watchGorgias() {
    var observed = [];

    function measure() {
      var frames = document.querySelectorAll('iframe[class*="gorgias-chat-key"]');
      var top = 0;

      Array.prototype.forEach.call(frames, function (frame) {
        var rect = frame.getBoundingClientRect();
        if (rect.height === 0) return;
        top = Math.max(top, Math.round(window.innerHeight - rect.top));
      });

      root.style.setProperty('--fb-gorgias-stack-top', top + 'px');

      if (window.ResizeObserver) {
        Array.prototype.forEach.call(frames, function (frame) {
          if (observed.indexOf(frame) !== -1) return;
          observed.push(frame);
          new ResizeObserver(measure).observe(frame);
        });
      }
    }

    measure();

    new MutationObserver(measure).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', measure, { passive: true });
  }

  function start() {
    init();
    watchPostscript();
    watchGorgias();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
